import { render, staticRenderFns } from "./CIndex.vue?vue&type=template&id=b6769872&"
import script from "./CIndex.vue?vue&type=script&lang=ts&"
export * from "./CIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports